import { z } from 'zod';

export const branchContactTypeSchema = z.object({
  id: z.number(),
  name: z.string(),
  address: z.string(),
  city: z.string(),
  phone: z.string(),
  email: z.string(),
  website: z.string(),
});

export type BranchContactType = z.infer<typeof branchContactTypeSchema>;
